import React, { useState } from 'react';
import styled from 'styled-components';
import rockProfile from 'assets/rock-profile.jpg';

function MyPictures() {
  const [enlarged, setEnlarged] = useState(false);

  return (
    <Container>
      {/* Lightbox overlay */}
      {enlarged && (
        <div className="lightbox" onClick={() => setEnlarged(false)}>
          <div className="lightbox__inner" onClick={e => e.stopPropagation()}>
            <div className="lightbox__titlebar">
              <span>Windows Picture and Fax Viewer - profile_pic_2005.jpg</span>
              <button className="lightbox__close" onClick={() => setEnlarged(false)}>✕</button>
            </div>
            <div className="lightbox__body">
              <img src={rockProfile} alt="profile_pic_2005.jpg" className="lightbox__img" />
            </div>
            <div className="lightbox__toolbar">
              <span className="lightbox__toolbar__info">profile_pic_2005.jpg — 1024 x 768 — JPEG Image</span>
            </div>
          </div>
        </div>
      )}

      <div className="toolbar">
        <span className="toolbar__title">My Pictures</span>
        <div className="toolbar__btns">
          <button className="toolbar__btn active">Thumbnails</button>
          <button className="toolbar__btn">Tiles</button>
          <button className="toolbar__btn">Icons</button>
          <button className="toolbar__btn">List</button>
        </div>
      </div>
      <div className="sidebar">
        <div className="sidebar__section">
          <div className="sidebar__title">Picture Tasks</div>
          <div className="sidebar__item" onClick={() => setEnlarged(true)}>View as a slide show</div>
          <div className="sidebar__item">Order prints online</div>
          <div className="sidebar__item">Print this picture</div>
        </div>
        <div className="sidebar__section">
          <div className="sidebar__title">File and Folder Tasks</div>
          <div className="sidebar__item">Make a new folder</div>
          <div className="sidebar__item">Share this folder</div>
        </div>
        <div className="sidebar__section">
          <div className="sidebar__title">Other Places</div>
          <div className="sidebar__item">My Documents</div>
          <div className="sidebar__item">My Computer</div>
        </div>
      </div>
      <div className="content">
        <div className="picture-card selected" onDoubleClick={() => setEnlarged(true)} onClick={() => setEnlarged(true)}>
          <img src={rockProfile} alt="profile_pic_2005.jpg" className="picture-img" />
          <div className="picture-label">profile_pic_2005.jpg</div>
          <div className="picture-info">134 KB - JPEG Image</div>
        </div>
      </div>
      <div className="statusbar">
        <span>1 object(s)</span>
        <span>134 KB</span>
      </div>
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #fff;
  font-size: 11px;
  font-family: Tahoma, sans-serif;
  position: relative;

  /* Lightbox overlay */
  .lightbox {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.75);
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .lightbox__inner {
    background: #ece9d8;
    border: 2px solid #0054e3;
    border-radius: 6px 6px 0 0;
    max-width: 90vw;
    max-height: 90vh;
    display: flex;
    flex-direction: column;
    box-shadow: 4px 4px 16px rgba(0, 0, 0, 0.5);
  }
  .lightbox__titlebar {
    background: linear-gradient(to right, #0054e3, #2b88d8);
    color: white;
    padding: 4px 8px;
    font-size: 11px;
    font-weight: bold;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-radius: 4px 4px 0 0;
  }
  .lightbox__close {
    background: #c0392b;
    color: white;
    border: 1px solid #922b21;
    border-radius: 3px;
    width: 20px;
    height: 18px;
    font-size: 10px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    &:hover { background: #e74c3c; }
  }
  .lightbox__body {
    flex: 1;
    overflow: auto;
    background: #333;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8px;
  }
  .lightbox__img {
    max-width: 80vw;
    max-height: 75vh;
    object-fit: contain;
    border: 1px solid #666;
  }
  .lightbox__toolbar {
    background: #ece9d8;
    padding: 4px 8px;
    font-size: 10px;
    color: #333;
    border-top: 1px solid #aca899;
    text-align: center;
  }

  .toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 2px 8px;
    background: linear-gradient(to bottom, #fff 0%, #ece9d8 100%);
    border-bottom: 1px solid #aca899;
  }
  .toolbar__title {
    font-weight: bold;
    color: #003399;
  }
  .toolbar__btns {
    display: flex;
    gap: 1px;
  }
  .toolbar__btn {
    font-size: 10px;
    padding: 1px 6px;
    border: 1px solid #aca899;
    background: #ece9d8;
    cursor: pointer;
    &.active {
      background: #fff;
      border-bottom-color: #fff;
    }
  }

  .sidebar {
    position: absolute;
    left: 0;
    top: 24px;
    bottom: 22px;
    width: 180px;
    background: linear-gradient(to bottom, #6b90da 0%, #4a6db5 3%, #6b90da 5%, #6b90da 100%);
    padding: 8px;
    overflow-y: auto;
  }
  .sidebar__section {
    background: #fff;
    border-radius: 5px;
    margin-bottom: 8px;
    padding: 6px 8px;
  }
  .sidebar__title {
    font-weight: bold;
    color: #003399;
    margin-bottom: 4px;
    font-size: 11px;
  }
  .sidebar__item {
    color: #0066cc;
    padding: 2px 0;
    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
  }

  .content {
    flex: 1;
    margin-left: 180px;
    padding: 20px;
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
    gap: 16px;
    overflow-y: auto;
    background: #fff;
  }
  .picture-card {
    width: 130px;
    text-align: center;
    padding: 6px;
    border: 1px solid transparent;
    border-radius: 3px;
    cursor: pointer;
    &.selected {
      background: #316ac5;
      border-color: #316ac5;
      color: #fff;
    }
    &:hover:not(.selected) {
      background: #e0e8f6;
      border-color: #a8c3e8;
    }
  }
  .picture-img {
    width: 120px;
    height: 120px;
    object-fit: cover;
    border: 1px solid #ccc;
  }
  .picture-label {
    margin-top: 4px;
    font-size: 11px;
    word-break: break-all;
  }
  .picture-info {
    font-size: 10px;
    opacity: 0.8;
  }

  .statusbar {
    display: flex;
    justify-content: space-between;
    padding: 2px 8px;
    background: #ece9d8;
    border-top: 1px solid #aca899;
    font-size: 11px;
    color: #333;
  }
`;

export default MyPictures;
